

import { Operator } from '../FbbEnum'
import { Coverage } from '../Coverage';
import { AddOnHometel } from './AddOnHometel'
import { AddOnMyTV } from './AddOnMyTV'
import { AddOnRouter } from './AddOnRouter'
// import { AddOnKKBox } from './AddOnKKBox'
import { AddOnNorton } from './AddOnNorton'
import { AddOnHomePhone } from './AddOnHomePhone'
import { AddOn } from './AddOn'
import * as log from '../../../common/js/appLogger'
import { AddOnHomePhonePlus } from './AddOnHomePhonePlus';
import { AddOnDummy } from './AddOnDummy';
import { AddOnMandatory } from './AddOnMandatory';
//import { Plan } from '../session/Plan'

//This is a special class that originally wanna put the methods to AddOn Class. But doing so the app will not able to run normally.
//If you have solution pls feel free to update.
export class AddOnUtil {

    static getLandingAddOnList(json:any) : Array<AddOn>{

        var list:Array<AddOn> = []
        list.push(new AddOnHomePhone())
        list.push(new AddOnMyTV())
        list.push(new AddOnRouter())
        // list.push(new AddOnKKBox())
        list.push(new AddOnNorton())
        // list.push(new AddOnDummy())

        //notes: mandatory VAS (disney+) do not need landing add on.

        // log.dt('[SPU7]', 'getLandingAddOnList')
        for(var addon of list){
            var j = AddOnUtil.findJson(json, addon.getKey())
            addon.parseConfig(j)
        }

        return list
    }

    static getSelectPlanAddOnList(json:any) : Array<AddOn>{

        var list:Array<AddOn> = []
        list.push(new AddOnHomePhonePlus())
        list.push(new AddOnHometel())
        list.push(new AddOnMyTV())
        //list.push(new AddOnRouter())
        // list.push(new AddOnKKBox())
        list.push(new AddOnNorton())

        // log.dt('[SPU7]', 'getSelectPlanAddOnList')
        for(var addon of list){
            var j = AddOnUtil.findJson(json, addon.getKey())
            addon.parseConfig(j)
        }

        return list
    }

    static findJson(jsonArray:any, key:string) : any{ 
        var landing = jsonArray['landing'] ?? []
        let jsonGroups:any = {}
        //log.ot('findJson', landing)
        for(var anAddonJson of landing){
            //log.dt('findJson', anAddonJson['id'])
            if ( ( anAddonJson['id'] ?? '_') === key || 
                    ( anAddonJson['id'] ?? '_').indexOf(key + '___') != -1 ){
                //return anAddonJson
                jsonGroups[anAddonJson['id']] = anAddonJson
                // log.dot('exList', anAddonJson)s
            }
        }
        //log.ot('jsonGroups', jsonGroups)
        return jsonGroups
    }

    // json: addon.json
    // addOnArr: current addon allowed
    static getConfigAddOnList(json:any, addOnAr:Array<AddOn>, planGroup:String) : Array<AddOn>{
        var list:Array<AddOn> = addOnAr
        //log.dt('[SPU7]', 'getConfigAddOnList: ' + planGroup)
        // log.dot('getConfigAddOnList', json)
        var finalList = [] //we need to perform some filter
        for(var addon of list){
            // log.dot('exList', addon.getKey())
            var j = AddOnUtil.findJson(json, addon.getKey())
            addon.parseConfig(j)

            let exList = ((j ?? {})[addon.getKey()] ?? {})?.exList ?? []
            //log.dot(addon.getKey(), (j ?? {})[addon.getKey()] ?? {})
            let isExclude = false
            for (var ex of exList){
                if ( ex == planGroup ){
                    log.dt('[SPU7] getConfigAddOnList', 'exclude ' + addon.getKey() + ' in ' + planGroup)
                    isExclude = true
                    break
                }
            }
            if ( !isExclude ){
                finalList.push(addon)
            }
        }

        return finalList
    }

    //template returned in get plan api's vasMandatory.vasTemplate
    //compare with addon.json
    static getMandatoryAddOnJson(addonJson: any, templateName: string, codeInfo: any) : AddOnMandatory | null{
        // log.dt('addonJson', addonJson.mandatory)
        if ( !addonJson.mandatory ){
            return null
        }
        for(let aJson of addonJson.mandatory){
            //log.dt('aJson', aJson)
            if ( aJson['id'] == templateName ){
                let addon = new AddOnMandatory()
                addon.setAddonJson(aJson)
                addon.setCodeInfo(codeInfo)
                return addon
            }
        }
        return null
    }

    static getAddOnList(operator:Operator, tech:String, 
                        hkbnCov:Coverage, contractMonth:number, bandwidth: String) : Array<AddOn>{

        log.it('getAddOnList', operator + ', ' + tech + ', ' + bandwidth)
        //log.i('getAddOnList|hkbnCov='+ hkbnCov.toString() + '|contractMonth=' + contractMonth );

        var list:Array<AddOn> = []
        
        list.push(new AddOnHomePhonePlus()) //all
        if ( operator === Operator.hkbn ){
            //Home Phone not ready at phase 1
            if ( tech.toUpperCase() === 'ME' ){
                if ( hkbnCov.getHaveHometelPort() ){
                    list.push(new AddOnHometel())
                }
            }
            else{
                list.push(new AddOnHometel())
            }
            //list.push(new AddOnMyTV())
            list.push(new AddOnRouter())
            if(contractMonth !== 12){
                list.push(new AddOnNorton())
            }
            
            //list.push(new AddOnKKBox())
            
        }
        else if ( operator === Operator.hgc ){
            //list.push(new AddOnMyTV())      
            list.push(new AddOnRouter())  
            if(contractMonth !== 12){
                list.push(new AddOnNorton())
            }
            //list.push(new AddOnKKBox())
        }
        else if ( operator === Operator.icable ){
            //list.push(new AddOnMyTV())
            list.push(new AddOnRouter())
            
            if(contractMonth !== 12){
                list.push(new AddOnNorton())
            }
            //list.push(new AddOnKKBox())
        }
        return list
    }

}